import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const API = `${window.location.origin}/api`;

export default function GoogleCallbackPage() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get('code');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError('Google login was cancelled or failed.');
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    if (!code) {
      setError('No authorization code received.');
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    const redirectUri = `${window.location.origin}/auth/google/callback`;

    axios.post(`${API}/auth/google/callback`, { code, redirect_uri: redirectUri })
      .then(res => {
        loginWithGoogle(res.data.token, res.data);
        if (res.data.role === 'admin' || res.data.role === 'super_admin') {
          navigate('/admin/dashboard');
        } else if (res.data.role === 'ambassador') {
          navigate('/ambassador');
        } else if (res.data.needs_phone) {
          navigate('/complete-profile-google-login');
        } else {
          navigate('/account');
        }
      })
      .catch(err => {
        setError(err.response?.data?.detail || 'Google login failed. Please try again.');
        setTimeout(() => navigate('/login'), 3000);
      });
  }, [searchParams, loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4" data-testid="google-callback-page">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-red-400 text-sm font-sans mb-2">{error}</p>
            <p className="text-white/30 text-xs font-sans">Redirecting to login...</p>
          </>
        ) : (
          <>
            <Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin mx-auto mb-3" />
            <p className="text-white/50 text-sm font-sans">Signing you in with Google...</p>
          </>
        )}
      </div>
    </div>
  );
}
